import type { IconNode } from '../types';

/**
 * @name hexagons-7
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNS4zIDQuM3YzLjlMMiAxMC4xdjMuOGwzLjMgMS45djMuOWwzLjQgMS45IDMuMy0xLjkgMy4zIDEuOSAzLjQtMS45di0zLjlsMy4zLTEuOXYtMy44bC0zLjMtMS45VjQuM2wtMy40LTEuOUwxMiA0LjMgOC43IDIuNFoiIC8+CiAgPHBhdGggZD0iTTEyIDguMlY0LjMiIC8+CiAgPHBhdGggZD0ibTE4LjcgOC4yLTMuNCAxLjkiIC8+CiAgPHBhdGggZD0ibTE1LjMgMTMuOSAzLjQgMS45IiAvPgogIDxwYXRoIGQ9Ik0xMiAxOS43di0zLjkiIC8+CiAgPHBhdGggZD0ibTguNyAxMy45LTMuNCAxLjkiIC8+CiAgPHBhdGggZD0ibTUuMyA4LjIgMy40IDEuOSIgLz4KICA8cGF0aCBkPSJtOC43IDEzLjkgMy4zIDEuOSAzLjMtMS45di0zLjhMMTIgOC4ybC0zLjMgMS45WiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hexagons-7
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hexagons7: IconNode = [
  [
    'path',
    {
      d: 'M5.3 4.3v3.9L2 10.1v3.8l3.3 1.9v3.9l3.4 1.9 3.3-1.9 3.3 1.9 3.4-1.9v-3.9l3.3-1.9v-3.8l-3.3-1.9V4.3l-3.4-1.9L12 4.3 8.7 2.4Z',
      key: 'vl4rs',
    },
  ],
  ['path', { d: 'M12 8.2V4.3', key: '1yh0kv' }],
  ['path', { d: 'm18.7 8.2-3.4 1.9', key: '135mew' }],
  ['path', { d: 'm15.3 13.9 3.4 1.9', key: '1ssf68' }],
  ['path', { d: 'M12 19.7v-3.9', key: 'plzx4q' }],
  ['path', { d: 'm8.7 13.9-3.4 1.9', key: '10a79s' }],
  ['path', { d: 'm5.3 8.2 3.4 1.9', key: '1a41h8' }],
  ['path', { d: 'm8.7 13.9 3.3 1.9 3.3-1.9v-3.8L12 8.2l-3.3 1.9Z', key: '12u8i2' }],
];

export default hexagons7;
